import { IChatEntity } from '../interfaces/chat-entity.interface';
import {
  EHistoryProvider,
  IHistoryFilter,
} from '../interfaces/history-filter.interface';
import { IHistoryItem } from '../interfaces/history-item.interface';
import { IPhoneCall } from '../interfaces/phone-call.interface';

export const historyFilter = (
  history: IHistoryItem,
  filter: IHistoryFilter,
) => {
  if (!filter) {
    return true;
  }

  // search filtering
  const { searchTerm, dateRange, orderBy, exceptions } = filter;

  let isIncluded = true;
  let isSearchExist = true;

  if (history.type === 'CHAT') {
    const item = history.item as IChatEntity;
    const provider = item.channelProvider as unknown as EHistoryProvider;

    isIncluded = exceptions.length === 0 ? true : exceptions.includes(provider);
    const identity = item.externalCustomerIdentity
      ? item.externalCustomerIdentity.toLowerCase()
      : '';
    const fullName = item.user.fullName ? item.user.fullName.toLowerCase() : '';
    const search = searchTerm ? searchTerm.trim().toLowerCase() : '';

    isSearchExist = search
      ? identity.includes(search) || fullName.includes(search)
      : true;
  } else {
    const item = history.item as IPhoneCall;
    isIncluded =
      exceptions.length === 0
        ? true
        : exceptions.includes(EHistoryProvider.PHONE);
    const phoneNumber = item.phoneNumber ? item.phoneNumber.toLowerCase() : '';
    const fullName = item.fullName ? item.fullName.toLowerCase() : '';
    const search = searchTerm ? searchTerm.trim().toLowerCase() : '';

    isSearchExist = search
      ? phoneNumber.includes(search) || fullName.includes(search)
      : true;
  }

  // date range filtering
  const isDateRangeExist = Object.values(dateRange).every(Boolean);
  const { field } = orderBy;
  const { fromDate, toDate } = dateRange;
  const dateA = history[field] as Date;
  const dateB = history[field] as Date;
  const isDateRangeCovered = isDateRangeExist
    ? dateA > fromDate && dateB < toDate
    : true;

  return isSearchExist && isDateRangeCovered && isIncluded;
};
